<template>
  <a :href="link.url" class="link" target="_blank" :style="{ color: palette }">
    <svg width="33" height="19" viewBox="0 0 33 19" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M23.088 1.482l8 8-8 8M.17 9.482h29.766" stroke="#fff" stroke-width="2"/></svg>
    <h5>{{ link.title }}</h5>
  </a>
</template>

<script>
export default {
  name: 'Link',
  props: {
    link: {
      type: Object,
      default: () => {
        return {
          title: '',
          url: ''
        };
      }
    },
    palette: {
      type: String,
      default: '#FFFFFF'
    }
  }
};
</script>

<style lang="scss" scoped>
.link {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 3rem;
  @media screen and (max-width: $mq-tablet) {
    margin-right: 0;
    margin-bottom: 1rem;
  }
  h5:hover {
    text-decoration: none;
  }
  svg {
    transition: transform $animationDuration;
    margin-right: $padding/4;
    path {
      stroke: currentColor;
    }
  }
  &:hover {
    svg {
      transform: translateX(8px);
    }
  }
}
a:hover {
  text-decoration: none;
}
</style>
